import type { VideoGameDto } from '@/api/backoffice-schemas';
import { GameIcon } from '@/components/GameIcon';
import { getGameFromBackofficeVideoGame } from '@/utils/gameMappers';

type GameStatusIconProps = {
  videoGame: VideoGameDto | undefined;
  status: string | null | undefined;
};

export const GameStatusIcon = ({ videoGame, status }: GameStatusIconProps) => {
  const getStatusText = () => {
    if (!status) {
      return '';
    }

    if (status === 'finished') {
      return 'Finished';
    }

    if (status === 'not_started') {
      return 'Upcoming';
    }

    return 'Live';
  };

  const game = getGameFromBackofficeVideoGame(videoGame?.slug);

  return (
    <div className="flex h-[53px] w-[53px] flex-col items-center justify-center gap-1 rounded-lg px-3">
      <GameIcon className="w-full" game={game} />
      <p className="font-normal text-[10px] text-gray leading-3">
        {getStatusText()}
      </p>
    </div>
  );
};
